import React from 'react'
import './ReservationRecord.css'
import { Input, Icon, Button, Form, DatePicker, message } from 'antd'
import request from '@/utils/request'
// import Cookies from 'js-cookie' // js-cookie
import { setKey, getKey } from '@/utils/Cookie'
import orderImg from '@/img/order.png'
import Auth from '@/utils/Auth'
const FormItem = Form.Item
const { RangePicker } = DatePicker

class ReservationRecord extends React.Component {
  state = {
    // ArrayData: [
    //   {
    //     name: '刘先生',
    //     type: 1,
    //     phone: '18787878787',
    //     IdCard: '19839348903489048',
    //     time: '2019年12月20日',
    //     status: 1
    //   },
    //   {
    //     name: '东方幼儿园',
    //     type: 2,
    //     phone: '18787878787',
    //     IdCard: '19839348903489048',
    //     time: '2019年12月20日',
    //     status: 1
    //   },
    //   {
    //     name: '东方幼儿园',
    //     type: 2,
    //     phone: '18787878787',
    //     IdCard: '19839348903489048',
    //     time: '2019年12月20日',
    //     status: 0
    //   }
    // ],
    ArrayData: [],
    facilityMarking: null,
    optionData: null
  }
  componentWillMount() {
    // console.log(Cookies.get('facilityMarking'))
    if (getKey('facilityMarking') && getKey('SCMT-ADMIN-TOKEN'))  {
      this.setState({
        facilityMarking: getKey('facilityMarking')
      })
      if (Auth.getType() == 'TeamAppointment') {
        //团队预约记录
        var obj = {
          facilityMarking: getKey('facilityMarking'),
          businessLicenseNumber: getKey('businessLicenseNumber')
            ? getKey('businessLicenseNumber')
            : ''
        }
      } else {
        var obj = {
          facilityMarking: getKey('facilityMarking'),
          businessLicenseNumber: ''
        }
      }

      this.setState({
        optionData: obj
      })
      this.getOrderList(obj)
    }else{
      message.error('您尚未登录，请登录');
      window.location = 'http://piao.scstm.com/' 
    }
  }
  //获取当前订单
  getOrderList = data => {
    request
      .get(
        `/v1/mobile/reserve/order?businessLicenseNumber=${data.businessLicenseNumber}&facilityMarking=${data.facilityMarking}`
      )
      .then(res => {
        // console.log('个人预约记录')
        // console.log(res)
        if (res && res.data && res.data.length > 0) {
          this.setState({
            ArrayData: res.data
          })
        }
      })
  }
  //取消预约
  CancleOrder = data => {
    // console.log(data)
    if (Auth.getType() == 'TeamAppointment') {//团队预约
      request
      .put(`/v1/group/reserve/mobile?id=${data.id}&tid=${data.tid}`)
      .then(res => {
        message.info('取消预约成功')
        this.getOrderList(this.state.optionData)
      })
    }else{
      request
      .put(`/v1/mobile/reserve/personal?id=${data.id}&tid=${data.tid}`)
      .then(res => {
        message.info('取消预约成功')
        this.getOrderList(this.state.optionData)
      })
    }

    // request
    //   .put(`/v1/mobile/reserve/personal?id=${data.id}&tid=${data.tid}`)
    //   .then(res => {
    //     message.info('取消预约成功')
    //     this.getOrderList(this.state.optionData)
    //   })
  }
  render() {
    const { ArrayData } = this.state
    return (
      <div className="ReservationRecord">
        {ArrayData && ArrayData.length > 0 ? (
          ArrayData.map((item, index) => {
            return (
              <div key={index} className="ReservationRecord_conten">
                <div className="ReservationRecord_conten_top">
                  <div className="left">
                    <img src={orderImg}></img>
                    <span className="name">{item.name}</span>
                    {item.type == 2 ? (
                      <span className="typePerson">个人预约</span>
                    ) : (
                        <span className="typeTeam">团队预约</span>
                      )}
                  </div>
                  <div className="right">
                    {item.status == 1 ? (
                      <span className="unPass">未到场</span>
                    ) : item.status == 2 ? (
                      <span className="unPass">已进场</span>
                    ) : item.status == 3 ? (
                      <span className="unPass">已退场</span>
                    ) : item.status == 4 ? (
                      <span className="unPass">审核失败</span>
                    ) : item.status == 0 ? (
                      <span className="cancle">已取消</span>
                    ) : item.status == 5 ? (
                      <span className="unPass">待审核</span>
                    ) : item.status == 6 ? (
                      <span className="cancle">已过期</span>
                    ) : null}
                  </div>
                </div>
                <div className="ReservationRecord_conten_bottom">
                  <div className="left">
                  <div className="item">
                      <span className="key">参馆日期：</span>
                      <span className="value">{item.time}</span>
                    </div>
                    <div className="item">
                      <span className="key">身份证号：</span>
                      <span className="value">{item.idCard}</span>
                    </div>
                    {item.mobile ? (
                      <div className="item">
                        <span className="key">手机号码：</span>
                        <span className="value">{item.mobile}</span>
                      </div>
                    ) : null}
                    {/* <div className="item">
                      <span className="key">手机号码：</span>
                      <span className="value">{item.mobile}</span>
                    </div> */}
                  </div>
                  {/* 暂时屏蔽 */}
                  {/* <div className="right">
                    {item.isShow == true ? (
                      <span
                        className="cancleText"
                        onClick={el => this.CancleOrder(item)}
                      >
                        取消预约
                      </span>
                    ) : null}
                  </div> */}
                </div>
              </div>
            )
          })
        ) : (
            <div style={{ width: '100%', marginTop: '160px', fontSize: '18px' }}>
              暂无预约记录
          </div>
          )}
      </div>
    )
  }
}
export default ReservationRecord
